"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prediction_model_results_viz_1 = require("@tableau/prediction-model-results-viz");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var RootReducer_1 = require("../../../app/RootReducer");
var styles = require("../../../styles/ModelResultStyles");
// Helper function to tell whether the curve is above the 45 degree or below 45 degree
var isModelResultBetterThanNoModel = function (coordinates) {
    var noModelScore = 0;
    var modelScore = 0;
    for (var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++) {
        var _a = coordinates_1[_i], x = _a[0], y = _a[1];
        if (x === y)
            continue;
        else if (y > x)
            modelScore++;
        else
            noModelScore++;
    }
    return modelScore >= noModelScore;
};
var ModelResultRocCurveChart = function (_a) {
    var width = _a.width;
    var _b = React.useState(undefined), highlight = _b[0], setHighlight = _b[1];
    var _c = (0, RootReducer_1.useAppSelector)(function (state) { return state.modelResult; }), currentThresholdClassification = _c.currentThresholdClassification, confusionMatricesClassification = _c.confusionMatricesClassification;
    var coordinates = confusionMatricesClassification.map(function (n) { return [n.falsePositiveRate, n.truePositiveRate]; });
    React.useEffect(function () {
        if (!currentThresholdClassification) {
            return;
        }
        setHighlight([currentThresholdClassification.falsePositiveRate, currentThresholdClassification.truePositiveRate]);
    }, [currentThresholdClassification]);
    var renderSummary = function () {
        var evaluation = isModelResultBetterThanNoModel(coordinates) ? Localize_1.Messages.betterText() : Localize_1.Messages.worseText();
        return (React.createElement("div", { className: styles.RocChartSummary },
            React.createElement("div", { className: styles.ThresholdSummary }, Localize_1.Messages.thresholdROCChartSummaryTitle({ evaluation: evaluation })),
            React.createElement("div", { className: styles.ThresholdSummaryDescription }, Localize_1.Messages.thresholdROCChartSummarySubtitle())));
    };
    return (React.createElement("div", { className: styles.ChartContainer },
        React.createElement(prediction_model_results_viz_1.LineChartComponent, { coordinates: coordinates, xAxisLabel: Localize_1.Messages.thresholdFprLabel(), yAxisLabel: Localize_1.Messages.thresholdTprLabel(), degree45Line: true, legend: { text: Localize_1.Messages.thresholdModel() }, highlight: highlight, drawPoint: true, width: width, height: width }),
        renderSummary()));
};
exports.default = ModelResultRocCurveChart;
//# sourceMappingURL=ModelResultRocCurveChart.js.map